module.exports = __webpack_public_path__ + "img/xijie0400.66489974.png";